module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    staticClass: "l-content l-card"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "card-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.card_image
    }
  })]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('v-ons-button', {
      key: category.pac_id,
      attrs: {
        "modifier": "large"
      },
      on: {
        "click": function($event) {
          return _vm.view(category)
        }
      }
    }, [_c('i', {
      class: category.pac_icon
    }), _vm._v(_vm._s(_vm.categoryName(category))), _c('i', {
      staticClass: "absoluteIcon",
      class: category.pac_icon
    })])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d09b854","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Card.vue
// module id = 215
// module chunks = 0